import type { FaireProductEntity } from "../../entity_types/product";

export const p_56ey49wv9j: FaireProductEntity = {
  token: "p_56ey49wv9j",
  type: "product",
  name: "Lara Floral Puff Sleeve Mini Dress",
  brandToken: "b_2mvdyzg3tq",
  brandName: "Olivaceous",
  imageUrl:
    "https://cdn.faire.com/fastly/90cb749e903982cb617cde0b4e3e4e03b15d66bff2f43afc9d3976b6d07b951d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/335fc73e2c317e0bc7a4f0e87a10a305dedc627273fa454ee68f18780e4774df.jpeg",
    "https://cdn.faire.com/fastly/5c03a610358d53cd48e4ebab863540716720f462c6a0e2d4960fe9f9ce206124.jpeg",
    "https://cdn.faire.com/fastly/0bb26bc9964ae3f1018c77b32eea483e7b486a67ffb037c78090c50c3f9b88ea.jpeg",
    "https://cdn.faire.com/fastly/cdf31fe13a8899f5ab21dc8ac29b402308424e38939940735c900aacbd6e5e1e.jpeg",
    "https://cdn.faire.com/fastly/35ef2fc92785bad6e5ff7f9aa9a28945500be838e0bdc07fd827a7c4bc57bab2.jpeg",
  ],
  priceDollars: 223.13,
  description:
    "Our Lara Floral Puff Sleeve Mini Dress features a charming floral print and voluminous puff sleeves for an effortlessly feminine look. Designed with a collared button-front silhouette and relaxed fit, it's perfect for Fall weekend outings, brunch dates, and seasonal styling.\n\nWoven",
  tags: [],
  msrpDollars: 446.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:53.755Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
